import React from 'react';

const PipeDriveCustomIcons = {
  'pipedrive-calendar': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 13h-5v5h5v-5zM16 2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-1V2h-2zm3 18H5V9h14v11z"
        fill="#404346"
        fillRule="evenodd"
      />
    </svg>
  ),
  'pipedrive-deal': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm.306-10.856c-1.783-.458-2.357-.933-2.357-1.672 0-.848.794-1.439 2.122-1.439 1.399 0 1.917.661 1.964 1.634h1.737c-.055-1.338-.88-2.567-2.522-2.964V5h-2.358v1.68c-1.525.327-2.75 1.307-2.75 2.808 0 1.796 1.5 2.69 3.693 3.212 1.965.467 2.358 1.151 2.358 1.874 0 .537-.386 1.393-2.122 1.393-1.62 0-2.256-.716-2.342-1.634H8c.094 1.704 1.383 2.66 2.892 2.98V19h2.358v-1.672C14.782 17.04 16 16.16 16 14.567c0-2.21-1.91-2.964-3.694-3.423z"
        fill="#404346"
        fillRule="evenodd"
      />
    </svg>
  ),
  'pipedrive-forecast': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.93 4.929c3.906-3.905 10.24-3.905 14.147 0l2.368-2.357v6.277l-6.298.008L17.505 6.5a7.777 7.777 0 0 0-11.003 0 7.77 7.77 0 0 0 0 11 7.777 7.777 0 0 0 11.003 0 7.714 7.714 0 0 0 2.264-5.5H22a9.948 9.948 0 0 1-2.924 7.071c-3.906 3.905-10.241 3.905-14.147 0-3.907-3.905-3.907-10.237 0-14.142zm7.326 6.392c1.486.365 3.078.963 3.078 2.716 0 1.266-1.015 1.963-2.292 2.192v1.327h-1.965v-1.34c-1.257-.253-2.332-1.012-2.41-2.364h1.44c.073.729.603 1.297 1.952 1.297 1.448 0 1.769-.68 1.769-1.105 0-.574-.328-1.118-1.965-1.488-1.827-.414-3.078-1.124-3.078-2.55 0-1.191 1.021-1.969 2.292-2.228V6.445h1.965v1.351c1.368.315 2.056 1.29 2.102 2.352h-1.447c-.04-.771-.472-1.296-1.638-1.296-1.107 0-1.768.47-1.768 1.142 0 .587.478.963 1.965 1.327z"
        fill="#404346"
        fillRule="nonzero"
      />
    </svg>
  ),
  'pipedrive-person': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12c2.486 0 4.5-2.014 4.5-4.5S14.486 3 12 3a4.499 4.499 0 0 0-4.5 4.5C7.5 9.986 9.514 12 12 12zm0 2c-3.004 0-9 1.563-9 4.667V21h18v-2.333C21 15.563 15.004 14 12 14z"
        fill="#404346"
        fillRule="evenodd"
      />
    </svg>
  ),
};

export default PipeDriveCustomIcons;
